import { render } from "./YoutubeSlider.vue?vue&type=template&id=4024e099&scoped=true"
import script from "./YoutubeSlider.vue?vue&type=script&lang=js"
export * from "./YoutubeSlider.vue?vue&type=script&lang=js"

import "./YoutubeSlider.vue?vue&type=style&index=0&id=4024e099&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4024e099"]])

export default __exports__